import { useTranslation } from "react-i18next";
import { LogOut } from "lucide-react";
import { NeuButton, NeuCard } from "../../components/neu/Neu";
import { useAuth } from "../../context/AuthContext";

export const SessionCard = () => {
  const { t } = useTranslation();
  const { signOut } = useAuth();
  return (
    <NeuCard className="p-6 sm:p-8" data-testid="session-card">
      <p className="label-xs text-sm">{t("app.signOut")}</p>
      <p className="mt-3 text-start text-base leading-7 text-muted-foreground">{t("app.signOutHint")}</p>
      <NeuButton
        data-testid="logout-btn"
        className="mt-4 flex w-full items-center justify-center gap-2 py-3.5 text-base text-destructive sm:w-auto sm:px-6"
        onClick={signOut}
      >
        <LogOut className="h-5 w-5" /> {t("app.signOut")}
      </NeuButton>
    </NeuCard>
  );
};
